export function applyPagination<T>(data: T[], pagination: { pageNumber: number; pageSize: number }): T[] {
  const { pageNumber, pageSize } = pagination;
  const start = (pageNumber - 1) * pageSize;
  const end = start + pageSize;
  return data.slice(start, end);
}
